import { ElementRef, ChangeDetectorRef, } from '@angular/core';
import { UsersService } from '../../services/users.service';
import { UserWaterViewModel } from '../../viewModels/userWater.viewModel';
var WaterMacroBarComponent = /** @class */ (function () {
    function WaterMacroBarComponent(usersService, changeDetectorRef) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this._date = null;
        this.animationPercent = 0;
        this.increase_per_step = 100;
        this.userWater = new UserWaterViewModel();
        this.userWater.water_target = 0;
        this.userWater.min_water_target = 0;
        this.userWater.consumed = 0;
    }
    Object.defineProperty(WaterMacroBarComponent.prototype, "date", {
        set: function (value) {
            var _this = this;
            this._date = value;
            // const percentB = document.getElementById('percentB');
            // const waterdrop = document.getElementById('waterdrop');
            // const waterdropWhite = document.getElementById('waterdrop-white');
            //
            // percentB.style.color = '#00ccff';
            // waterdrop.style.display = 'block';
            // waterdropWhite.style.display = 'none';
            // this.animationPercent = 0;
            this.usersService.getUserWater(this._date).subscribe(function (userWater) {
                _this.userWater = userWater;
                var newPercent = _this.userWater.consumed * 100 / _this.userWater.water_target;
                if (newPercent >= 95) {
                    newPercent = 90;
                }
                _this.changeDetectorRef.detectChanges();
                // this.animateTo(newPercent);
            });
        },
        enumerable: true,
        configurable: true
    });
    WaterMacroBarComponent.prototype.fixedNumber = function (number) {
        if (number === 0) {
            return 0;
        }
        return (number / 1000).toFixed(1);
    };
    WaterMacroBarComponent.prototype.increase = function () {
        var ml = this.userWater.consumed + this.increase_per_step;
        var target_ml = this.userWater.water_target;
        var new_percent = ml * 100 / target_ml;
        if (ml > target_ml) {
            return;
        }
        if (new_percent >= 95) {
            new_percent = 90;
        }
        this.updateMl(this.increase_per_step);
        this.userWater.consumed = ml;
        this.changeDetectorRef.detectChanges();
        // this.animateTo(new_percent);
    };
    WaterMacroBarComponent.prototype.animateTo = function (newPercent) {
        var _this = this;
        var percentB = document.getElementById('percentB');
        var water = document.getElementById('water');
        var waterdrop = document.getElementById('waterdrop');
        var waterdropWhite = document.getElementById('waterdrop-white');
        var percent = this.animationPercent;
        var interval;
        interval = setInterval(function () {
            percent += 5;
            // @ts-ignore
            water.style.transform = 'translate(0' + ',' + (100 - percent) + '%)';
            if (percent > 50) {
                percentB.style.color = '#fff';
                waterdrop.style.display = 'none';
                waterdropWhite.style.display = 'block';
            }
            if (percent >= newPercent) {
                _this.animationPercent = newPercent;
                clearInterval(interval);
            }
        }, 120);
    };
    WaterMacroBarComponent.prototype.percentage = function (number1, dividedByNumber2) {
        if (!dividedByNumber2 || dividedByNumber2 <= 0) {
            return '0%';
        }
        var percentage = Math.round((number1 / dividedByNumber2) * 100);
        if (percentage > 100) {
            percentage = 100;
        }
        return percentage + '%';
    };
    WaterMacroBarComponent.prototype.updateMl = function (add_ml) {
        this.usersService.addUserWater(this._date, { add_ml: add_ml }).subscribe();
    };
    return WaterMacroBarComponent;
}());
export { WaterMacroBarComponent };
